export default __webpack_public_path__ + "static/media/andre.20eb1d58.jpg";